<template>
  <footer class="bg-white border-t border-gray-200 mt-12">
    <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="space-y-8 xl:col-span-1">
          <img class="h-6" src="@/assets/images/logo.png" alt="Company name" />
          <p class="text-gray-500 text-base leading-6">
            Logrando los mayores beneficios y la mejor experiencia en la compra de seguros
          </p>
          <div class="flex space-x-6">
            <a href="https://www.facebook.com/Cabsa.mx" target="_blank" class="text-gray-400 hover:text-gray-500">
              <span class="sr-only">Facebook</span>
              <svg class="h-6 w-6" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" >
                <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="https://www.instagram.com/Cabsa.mx/" target="_blank" class="text-gray-400 hover:text-gray-500">
              <span class="sr-only">Instagram</span>
              <svg class="h-6 w-6" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" >
                <path fill-rule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="https://twitter.com/CabsaMx" target="_blank" class="text-gray-400 hover:text-gray-500">
              <span class="sr-only">Twitter</span>
              <svg class="h-6 w-6" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" >
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/Cabsamx" target="_blank" class="text-gray-400 hover:text-gray-500">
              <span class="sr-only">Linkedin</span>
              <svg height="24px" fill="currentColor" version="1.1" viewBox="0 0 512 512" width="24px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M256,0c141.29,0 256,114.71 256,256c0,141.29 -114.71,256 -256,256c-141.29,0 -256,-114.71 -256,-256c0,-141.29 114.71,-256 256,-256Zm-80.037,399.871l0,-199.921l-66.464,0l0,199.921l66.464,0Zm239.62,0l0,-114.646c0,-61.409 -32.787,-89.976 -76.509,-89.976c-35.255,0 -51.047,19.389 -59.889,33.007l0,-28.306l-66.447,0c0.881,18.757 0,199.921 0,199.921l66.446,0l0,-111.65c0,-5.976 0.43,-11.95 2.191,-16.221c4.795,-11.935 15.737,-24.299 34.095,-24.299c24.034,0 33.663,18.34 33.663,45.204l0,106.966l66.45,0Zm-272.403,-296.321c-22.74,0 -37.597,14.95 -37.597,34.545c0,19.182 14.405,34.544 36.717,34.544l0.429,0c23.175,0 37.6,-15.362 37.6,-34.544c-0.43,-19.595 -14.424,-34.545 -37.149,-34.545Z"/></svg>
            </a>
          </div>
        </div>
        <div class="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4 class="text-sm leading-5 font-semibold text-gray-400 tracking-wider uppercase" >
                Servicios
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="autos" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Autos
                  </a>
                </li>
                <li>
                  <a href="autos-empresa" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Autos Empresa
                  </a>
                </li>
                <!-- <li>
                  <a href="life" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Vida
                  </a>
                </li-->
                <li>
                  <a href="salud" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Salud
                  </a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h4 class="text-sm leading-5 font-semibold text-gray-400 tracking-wider uppercase" >
                Legales
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="/aviso-de-privacidad" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Aviso de privacidad
                  </a>
                </li>
                <li>
                  <a href="/terminos-y-condiciones" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Términos y condiciones
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4 class="text-sm leading-5 font-semibold text-gray-400 tracking-wider uppercase" >
                Compañia
              </h4>
              <ul class="mt-4 space-y-4">
                <li>
                  <a href="" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Blog
                  </a>
                </li>
                <li>
                  <a href="./#nosotros" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Nosotros
                  </a>
                </li>
                <li>
                  <a href="contactanos" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    Contacto
                  </a>
                </li>
                <li>
                  <a href="" class="text-base leading-6 text-gray-500 hover:text-gray-900" >
                    WhatsApp
                  </a>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </div>
      <div class="mt-12 border-t border-gray-200 pt-8">
        <p class="text-base leading-6 text-gray-400 xl:text-center">
          &copy; 2024 Cabsa. Todos los derechos reservados.
        </p>
      </div>
    </div>
  </footer>
</template>